import React from 'react';
import {useSearchParams} from 'react-router-dom';

import PatientSignupV1 from './PatientOnboardingPage';
import PatientSignupV2 from './PatientSignupV2';

const PatientSignupWrapper = props => {
  const [search] = useSearchParams();
  const version = search.get('version') || 'v1';
  return (
    version === 'v2'
    ? <PatientSignupV2 {...props}/>
    : <PatientSignupV1 {...props}/>
  );
};

export default PatientSignupWrapper;

